var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSquaresLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50) scale(0.7000000000000001) translate(-50 -50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    keySplines: "0 1 0 1;0 1 0 1;0 1 0 1;0 1 0 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "0 50 50;90 50 50;180 50 50;270 50 50;360 50 50",
    dur: "4s",
    calcMode: "spline",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    keySplines: "0.5 0.5 0.5 0.5;1 0 0 1;1 0 0 1",
    keyTimes: "0;0.01;0.5;1",
    values: "0.5;1;1;0.5",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "1s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 25)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bcd3ff",
    height: 52,
    width: 52,
    y: -25,
    x: -25
  }, /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 1 0 1;0 1 0 1;0 1 0 1;0 1 0 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "#bcd3ff;#78a8ff;#4286ff;#026bff;#bcd3ff",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "4s",
    attributeName: "fill"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 75)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bcd3ff",
    height: 50,
    width: 52,
    y: -25,
    x: -25
  }, /*#__PURE__*/React.createElement("animateTransform", {
    keySplines: "1 0 0 1;1 0 0 1",
    keyTimes: "0;0.5;1",
    values: "0;1;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "1s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 1 0 1;0 1 0 1;0 1 0 1;0 1 0 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "#bcd3ff;#78a8ff;#4286ff;#026bff;#bcd3ff",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "4s",
    attributeName: "fill"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75 25)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bcd3ff",
    height: 52,
    width: 50,
    y: -25,
    x: -25
  }, /*#__PURE__*/React.createElement("animateTransform", {
    keySplines: "1 0 0 1;1 0 0 1",
    keyTimes: "0;0.5;1",
    values: "0;1;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "1s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 1 0 1;0 1 0 1;0 1 0 1;0 1 0 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "#bcd3ff;#78a8ff;#4286ff;#026bff;#bcd3ff",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "4s",
    attributeName: "fill"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75 75)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bcd3ff",
    height: 50,
    width: 50,
    y: -25,
    x: -25
  }, /*#__PURE__*/React.createElement("animateTransform", {
    keySplines: "1 0 0 1;1 0 0 1",
    keyTimes: "0;0.5;1",
    values: "0;1;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "1s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 1 0 1;0 1 0 1;0 1 0 1;0 1 0 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "#bcd3ff;#78a8ff;#4286ff;#026bff;#bcd3ff",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "4s",
    attributeName: "fill"
  })))))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSquaresLoading);
export default __webpack_public_path__ + "static/media/blue-squares-loading.5d923c26f1da6b435c8f0f258a8e3a58.svg";
export { ForwardRef as ReactComponent };